export default "__VITE_ASSET___ROVyaL7__"